import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b8a95dac&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./styles.scss?vue&type=style&index=0&id=b8a95dac&prod&lang=scss&scoped=true&external"
import style1 from "./index.vue?vue&type=style&index=1&id=b8a95dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8a95dac",
  null
  
)

export default component.exports